#!/usr/bin/env node
import { Command } from "commander";
import pkg from "../package.json";
import { loadUserConfig } from "../shared/configLoader";

import { build, print, types, generate, watch, validate } from "./commands";
import { GenerateOptions } from "./commands";

async function main() {
  const program = new Command();
  const config = loadUserConfig();
  const version = pkg.version;

  const inputOption = (defaultVal: string): [string, string, string] => [
    "-i, --input <file>",
    "Input .envx file",
    defaultVal,
  ];

  const outputEnvOption = (defaultVal: string): [string, string, string] => [
    "-o, --output <file>",
    "Output .env file",
    defaultVal,
  ];

  const metaFileOption = (defaultVal: string): [string, string, string] => [
    "-m, --metaFilePath <file>",
    "Output metaJsonFile Folder Path (envx.meta.json)",
    defaultVal,
  ];

  const typesOutputOption = (defaultVal: string): [string, string, string] => [
    "-t, --typesOutput <file>",
    "Output .ts file",
    defaultVal,
  ];

  program
    .name("typenv")
    .description("Enhanced CLI for .envx - Manage .envx files effortlessly")
    .version(version);

  program
    .command("build")
    .description(
      "Create a standard .env file by compiling your .envx configuration"
    )
    .option(...inputOption(config.input || ".envx"))
    .option(...outputEnvOption(config.outputs?.env || ".env"))
    .option(...metaFileOption(config.outputs?.metaFilePath || "."))
    .option(
      "--overwrite",
      "Overwrite output files if they exist",
      config.overwrite || false
    )
    .action(build);

  program
    .command("generate")
    .alias("gen")
    .description("Generate TypeScript types and build .env file from .envx")
    .option(...inputOption(config.input || ".envx"))
    .option(...outputEnvOption(config.outputs?.env || ".env"))
    .option(...typesOutputOption(config.outputs?.types || "types/envx.ts"))
    .option(...metaFileOption(config.outputs?.metaFilePath || "."))
    .option(
      "--overwrite",
      "Overwrite output files if they exist",
      config.overwrite || false
    )
    .action(async (options: GenerateOptions) => {
      const sharedOptions = {
        ...options,
        noTypes: true,
      };
      return await generate(sharedOptions);
    });

  program
    .command("watch")
    .description(
      "Watch .envx file and automatically regenerate .env and types on changes"
    )
    .option(...inputOption(config.input || ".envx"))
    .option(...outputEnvOption(config.outputs?.env || ".env"))
    .option(...typesOutputOption(config.outputs?.types || "types/envx.ts"))
    .option(...metaFileOption(config.outputs?.metaFilePath || "."))
    .option("--no-types", "Skip generating TypeScript types during watch")
    .option("--no-build", "Skip generating .env file during watch")
    .option("--silent", "Suppress console output while watching")
    .action(watch);

  program
    .command("validate")
    .description(
      "Validate your .envx file against its schema to catch errors early"
    )
    .option(...inputOption(config.input || ".envx"))
    .action(validate);

  program
    .command("print")
    .description("Print the parsed .envx file content as JSON for inspection")
    .option(...inputOption(config.input || ".envx"))
    .action(print);

  program
    .command("types")
    .description(
      "Generate TypeScript definitions based on your schema for type safety"
    )
    .option(...inputOption(config.input || ".envx"))
    .option(...typesOutputOption(config.outputs?.types || "types/envx.ts"))
    .option(...metaFileOption(config.outputs?.metaFilePath || "."))
    .action(types);

  await program.parseAsync();
}

main();
